module.exports = __webpack_public_path__ + "img/32.396d76f5.jpg";